/* eslint jsx-a11y/no-autofocus: off */
import React, { useState } from 'react';
import { AnySchema } from 'yup';

import styles from '../Table.module.scss';

interface Props {
  value: string;
  validationSchema: AnySchema;
  onValidationFailure: (error: string) => void;
  onConfirm: (value: any) => void;
}

const InputCell = ({
  value: defaultValue,
  validationSchema,
  onConfirm,
  onValidationFailure,
}: Props) => {
  const [value, setValue] = useState(defaultValue);
  const [editMode, setEditMode] = useState(false);

  let submitted = false;

  const validateAndConfirm = async () => {
    setEditMode(false);
    if (submitted) return;
    submitted = true;

    try {
      await validationSchema?.validate(value);
      onConfirm(value);
    } catch (error) {
      setValue(defaultValue);
      onValidationFailure?.(error.message);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value ?? '');
  };

  const handleBlur = () => validateAndConfirm();

  const handleKeydown = (event: React.KeyboardEvent) => {
    if (event.code === 'Delete') event.stopPropagation();
    if (event.code === 'Enter') validateAndConfirm().then(() => {});
  };

  return (
    <td onDoubleClick={() => setEditMode(true)}>
      {editMode ? (
        <input
          className={styles.table__cell_input}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleKeydown}
          autoFocus
        />
      ) : (
        value
      )}
    </td>
  );
};

export default InputCell;
